import { z } from 'zod';
import { createTextToast } from '@/utils/ToastUtils.ts';

const SyncToastValueSchema = z.object({
    title: z.string(),
    description: z.string().optional(),
    variant: z.enum(['default', 'destructive', 'success']),
});

export const syncToastHandler = (rawValue: object) => {
    const value = SyncToastValueSchema.parse(rawValue);

    createTextToast(value.title, value.description, value.variant, false);
};
